const e=["left","center","right"],t={align:{type:"enum",className:"rt-r-ta",values:e,responsive:!0}};export{t as textAlignPropDef};
//# sourceMappingURL=text-align.prop.js.map
